import { React } from "react";
import Sidebar from "../../Components/Sidebar/sidebar";
import { Layout } from "antd";
import { Routes, Route } from "react-router-dom";
import HeaderNav from "../../Components/Header/Header";
import StockRecords from "./StockRecords/StockRecords";
const { Content } = Layout;

const StockManagement = (props) =>{

    const listItems = [
        {
             icon: "jobcard-icon",
             label: "Stock Records",
             link: "stock-records",
        }
    ];

    return (
        <Layout>
          <HeaderNav />
          <Layout>
            <Sidebar headerName="Stock Management" listItems={listItems} />
            <Layout>
              <Content>
                <Routes>
                  <Route path="/stock-records" element={<StockRecords />} />
                </Routes>
              </Content>
            </Layout>
          </Layout>
        </Layout>
      );
};

export default StockManagement;